<template>
    <a-modal :title="dataInfo.name" :visible="visible" :confirm-loading="confirmLoading" :width="800" @ok="handleOk" @cancel="handleCancel">
        <div class="title strong">{{ $t('goods.ticket_info' /* 门票信息 */) }}</div>
        <div class="goods-info-box flex x-left y-top mt20">
            <div class="left">
                <div class="logo">
                    <img :src="dataInfo.prod_img | urlFilter(360)" alt="" />
                </div>
                <div class="price pl10">
                    <!--基础价格-->
                    {{ $t('store.basic_price') }}：
                    <span class="error-color">￥{{ dataInfo.price }}</span>
                </div>
                <div class="stock pl10">
                    <!--剩余库存-->
                    {{ $t('store.remaining_inventory') }}：{{ popupData.is_limit == 0 ? '无限量' : dataInfo.inventory + ' 件' }}
                </div>
                <div class="limit pl10">{{ $t('store.per_capita_limit') }}：{{ dataInfo.limit_num }}</div>
            </div>
            <div class="right">
                <a-row>
                    <a-col span="12">
                        <div class="value">
                            <!--门票名称-->
                            {{ $t('store.goods_name') }}：{{ dataInfo.name }}
                        </div>
                    </a-col>
                    <a-col span="12">
                        <div class="value">
                            <!--门票编号-->
                            {{ $t('store.goods_number') }}：{{ dataInfo.number }}
                        </div>
                    </a-col>
                    <a-col span="12">
                        <div class="value">
                            <!--门票类型-->
                            {{ $t('store.goods_type') }}：{{ dataInfo.type_name }}
                        </div>
                    </a-col>
                    <a-col span="12">
                        <div class="value">
                            <!--状态-->
                            {{ $t('store.status') }}：
                            <!--dataInfo.status == 1 ? '上架' : '下架'-->
                            <a-tag color="green" v-if="dataInfo.status == 1">
                                <!--上架-->
                                {{ $t('store.put_away') }}
                            </a-tag>
                            <a-tag color="red" v-if="dataInfo.status == 0">
                                <!--下架-->
                                {{ $t('store.sold_out') }}
                            </a-tag>
                        </div>
                    </a-col>
                    <a-col span="12">
                        <div class="value">
                            <!--创建人-->
                            {{ $t('store.creator') }}：{{ dataInfo.real_name }}
                        </div>
                    </a-col>
                    <a-col span="12">
                        <div class="value">
                            <!--创建时间-->
                            {{ $t('store.creation_time') }}：{{ dataInfo.create_time }}
                        </div>
                    </a-col>
                    <a-col span="24">
                        <div class="value">
                            <!--销售时段-->
                            {{ $t('store.sales_period') }}：{{ dataInfo.start_time }} ~ {{ dataInfo.end_time }}
                        </div>
                    </a-col>
                    <a-col span="24">
                        <div class="value">
                            <!--门票简介-->
                            {{ $t('store.goods_brief') }}：
                        </div>
                        <div class="value" v-html="dataInfo.introduction"></div>
                    </a-col>
                </a-row>
            </div>
        </div>

        <div class="allocation-box mt20">
            <a-spin :spinning="confirmLoading">
                <div class="header flex y-center">
                    <div class="title strong">
                        <!--分配信息-->
                        {{ $t('store.distribution_information') }}
                    </div>
                    <div class="hint">
                        <!--剩余库存量-->
                        {{ $t('store.remaining_inventory') }}：{{ popupData.is_limit == 0 ? $t('store.unlimited') : popupData.assignable }}
                        <!--件-->
                        {{ $t('store.piece') }}
                        <span style="color: #56aafe; cursor: pointer" @click="getData"><a-icon type="redo" /></span>
                    </div>
                </div>
                <!-- 表格 -->
                <a-table :rowKey="record => record.id" :columns="columns" :data-source="popupData.forum_list" class="mt10" :loading="loading">
                    <!--        序号        -->
                    <span slot="index" slot-scope="text, record, index">{{ index + 1 }}</span>

                    <span slot="customAction" v-if="popupData.is_limit == 1">
                        <a-popover title="" :content="$t('store.distribution_total_not_greater_than_inventory')" trigger="hover">
                            <a-icon type="exclamation-circle" style="color: #56aafe" />
                        </a-popover>
                        <!--分配量-->
                        {{ $t('store.distribution_volume') }}
                    </span>

                    <!--        分配量        -->
                    <span slot="action" slot-scope="text, record" v-if="popupData.is_limit == 1">
                        <a-input-number :precision="0" :min="0" size="small" v-model="record.assignable" />
                        <!--件-->
                        {{ $t('store.piece') }}
                    </span>

                    <!--  是否可售   -->
                    <span slot="isSaleAction" slot-scope="text, record">
                        <a-switch :checked-children="$t('layout.yes')" :un-checked-children="$t('layout.no')" v-model="record.isSale" />
                    </span>

                    <span slot="status" slot-scope="text">
                        <a-badge :status="text | statusTypeFilter" :text="text | statusFilter(statusFilter)" />
                    </span>
                </a-table>
            </a-spin>
        </div>
    </a-modal>
</template>

<script>
const statusTypeFilter = {
    0: 'error',
    1: 'processing'
};
export default {
    name: 'GoodsAllocation',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        dataInfo: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            confirmLoading: false,
            columns: [
                {
                    // title: '序号',
                    title: this.$t('layout.serial_number'),
                    align: 'center',
                    scopedSlots: { customRender: 'index' }
                },
                {
                    // title: '分论坛名称',
                    title: this.$t('store.sub_forum_name'),
                    dataIndex: 'name',
                    align: 'center'
                },
                {
                    // title :'论坛状态',
                    title: this.$t('store.forum_status'),
                    dataIndex: 'status',
                    scopedSlots: { customRender: 'status' },
                    align: 'center'
                },
                {
                    // title: '截止日期',
                    title: this.$t('store.deadline'),
                    dataIndex: 'end_time',
                    align: 'center'
                },
                {
                    title: '是否可售',
                    dataIndex: 'isSale',
                    scopedSlots: { customRender: 'isSaleAction' }
                }
                // {
                //     scopedSlots: { customRender: 'action' },
                //     slots: { title: 'customAction' },
                //     align: 'center'
                // }
            ],
            data: [],
            loading: false,
            popupData: {},
            statusFilter: {
                /*0: '已结束',
                    1: '进行中',*/
                0: this.$t('store.ended'),
                1: this.$t('store.in_progress')
            }
        };
    },
    created() {
        this.$watch('dataInfo', val => {
            if (Object.keys(val).length) {
                this.confirmLoading = true;
                this.getData();
            }
        });
    },
    filters: {
        statusTypeFilter(value) {
            return statusTypeFilter[value];
        },
        statusFilter(value, statusFilter) {
            return statusFilter[value];
        }
    },
    methods: {
        getData() {
            let data = {
                goods_id: this.dataInfo.id
            };
            this.$request.get({ url: 'allocateGoods', data }).then(res => {
                res.data.forum_list.forEach(item => {
                    item.isSale = item.assignable_status == 1; // 0否、1是  是否可售
                });
                if (res.code === 200) {
                    this.confirmLoading = false;
                    this.popupData = res.data;
                }
            });
        },
        handleOk(e) {
            let data = [];
            let num = 0;
            this.popupData.forum_list.forEach(item => {
                let json = {
                    forum_id: item.id
                };
                if (this.popupData.is_limit == 1) {
                    num += parseInt(item.assignable);
                    json.num = item.assignable;
                }
                json.status = item.isSale ? 1 : 0;
                data.push(json);
            });

            if (this.popupData.is_limit == 1 && num > this.popupData.assignable) {
                // this.$message.error('分配总量不得大于剩余库存量');
                this.$message.error(this.$t('store.distribution_total_not_greater_than_remaining_inventory'));
                return false;
            }
            data = JSON.stringify(data);
            console.log(data);
            this.$request.post({ url: 'setForumAllocateNum', data: { goods_id: this.dataInfo.id, forum_value: data } }).then(res => {
                // this.$message.success('操作成功');
                this.$message.success(this.$t('layout.operation_success'));
                this.$emit('ok');
            });
        },
        handleCancel(e) {
            this.$emit('close');
        }
    }
};
</script>

<style scoped lang="less">
.goods-info-box {
    .left {
        width: 200px;
        flex-shrink: 0;
        .logo {
            width: 100%;
            border: 1px solid #e8e8e8;
            border-radius: 4px;
            display: flex;
            justify-content: center;
            align-items: center;
            border: 1px solid #e8e8e8;
            border-radius: 4px;
            padding: 6px;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                object-position: center top;
            }
        }
        .price {
            font-size: 14px;
            color: #333;
            margin-top: 10px;
        }
        .stock,
        .limit {
            font-size: 14px;
            color: #666;
        }
    }
    .right {
        flex: 1;
        padding-left: 20px;
        .value {
            font-size: 14px;
            color: #666;
            margin-bottom: 10px;
        }
    }
}
</style>